import { observer } from "mobx-react";
import React from "react";
import adminStore from "../../stores/adminStore";
import { ScoreByCompetence } from "./ScoreByCompetence";
import { ScoreByArea, ScoreByCharge, ScoreByChargeByCompetence, ScoreByAreaByCompetence, scoreByDataByData2 } from "./ScoreByArea";

@observer
class ResultScore extends React.Component {
    constructor(props) {
        super(props)
        this.state = { currentArea: undefined }
    }

    componentDidMount() {
        this.setState({ currentArea: adminStore.dashboard.areas[0] })
    }

    render() {
        const { dashboard } = adminStore;
        if (!dashboard.scores_by_areas_by_charges_by_competences) {
            return <div></div>;
        }

        const { areas } = dashboard
        const { data, competences } = dashboard.scores_by_areas_by_charges_by_competences
        let { currentArea } = this.state
        if (!currentArea) currentArea = dashboard.areas[0]

        return (
            <div>
                <div>
                    <h4> Score por Competencia </h4>
                    <ScoreByCompetence />
                </div>
                <br />
                <div>
                    <h4> Score por Area </h4>
                    <ScoreByArea />
                </div>
                <br />
                <div>
                    <h4> Score por Area y Competencia </h4>
                    <ScoreByAreaByCompetence />
                </div>
                <br />
                <div>
                    <h4> Score por Cargo </h4>
                    <ScoreByCharge />
                </div>
                <br />
                <div>
                    <h4> Score por Cargo y Competencia </h4>
                    <ScoreByChargeByCompetence />
                </div>
                <div>
                    <h4>Por Area y Cargo</h4>
                    <select
                        className="form-select"
                        id="inputArea"
                        aria-label="Selecciona el Area para ver los resultados por Cargo"
                        onChange={({target}) => this.setState({currentArea: target.value})}
                        value={currentArea}
                    >
                        <option key={""} value="" className="selected">
                            Selecciona el Area para ver los resultados por Cargo
                        </option>
                        {areas.map((a) => <option key={a} value={a}> {a} </option> )}
                    </select>
                    <br />

                    { currentArea in data && scoreByDataByData2(data[currentArea], competences) }
                </div>
            </div>
        );
    }
}

export { ResultScore };

